angular
	.module("accordionAppropriateVerification.components", [])
	.component("accordionAppropriateVerification", {
		templateUrl: "ng/components/accordionAppropriateVerification/accordionAppropriateVerification.view.html",
		bindings: {
			selectedValueOk: "&",
			model: "<",
			selectedValueNotOk: "&",
			riUserG: "<",
			isPv: '<',
			saePvControl: '<',
			id: "<"
		},
		controllerAs: "AppropriateVerificationCtrl",
		controller: function (
			$rootScope,
			$typeDomainService,
			$arcService,
			$contractService) {
			var self = this;

			self.$onInit = function () {
				self.adeguataVerifica = {
					codiceNaturaClientela: "",
					motivoRapporto: "",
					provinciaAttivita: "",
					stato: ""

				};

				self.dropdown = {
					codiceNaturaClientela: [],
					motivoRapporto: [],
					comuni: $rootScope.comuniMap,
					nazioni: $rootScope.nazioniEstere
				};

				//Retrieve select values
				getProvince();
				getCustomerNature();
				getMr();

				if (self.model.codiceNaturaClientela && self.model.codiceNaturaClientela.value) {
					self.adeguataVerifica.codiceNaturaClientela =
						self.model.codiceNaturaClientela;
				}
				if (self.model.motivoRapporto && self.model.motivoRapporto.value) {
					self.adeguataVerifica.motivoRapporto =
						self.model.motivoRapporto;
				}
				if (self.model.provinciaAttivita) {
					self.adeguataVerifica.provinciaAttivita =
						self.model.provinciaAttivita;
				}
				if (self.model.stato) {
					self.adeguataVerifica.stato = self.model.stato;
				}
				self.check();
			};

			var getProvince = function () {
				self.inputProvAttivita = self.dropdown.comuni
					.map(function (comune) {
						return comune.sigla;
					})
					.filter(function (siglaComune) {
						return siglaComune != "";
					})
					.sort()
					.reduce(function (result, nextItem) {
						return result.includes(nextItem) ? result : result.concat(nextItem);
					}, []);

				self.inputProvAttivita.push('EE');
			};

			var getCustomerNature = function () {
				if (self.isPv) {
					$arcService
						.customerNaturaAdv()
						.then(function (response) {
							self.dropdown.codiceNaturaClientela = response.domainList;
						})
						.catch(function (error) {
							console.log("error:", error);
						});

				} else {
					$contractService
						.customerNaturaAdvDigital(self.id)	
						.then(function (response) {
							self.dropdown.codiceNaturaClientela = response.domainList;
						})
						.catch(function (error) {
							console.log("error:", error);
						});

				}

			};

			var getMr = function () {
				$typeDomainService
					.getDomainSet("RI_DROPDOWN_DOMAINS", "MR")
					.then(function (response) {
						self.dropdown.motivoRapporto = response.domainList;
					})
					.catch(function (error) {
						console.log("error:", error);
					});
			};

			self.onChange = function (value, tipo) {
				switch (tipo) {
					case "naturaClientela":
						self.adeguataVerifica.codiceNaturaClientela = value;
						checkCongruenza(value);
						break;
					case "motivoRapporto":
						self.adeguataVerifica.motivoRapporto = value;
						break;

					case "provAttivita":
						self.adeguataVerifica.provinciaAttivita = value;
						break;
					case "stato":
						self.adeguataVerifica.stato = value;
						self.model.stato = value;
						break;
				}
				self.check();
			};

			self.check = function () {
				if (
					self.adeguataVerifica.codiceNaturaClientela.value &&
					self.adeguataVerifica.motivoRapporto.value &&
					(self.adeguataVerifica.provinciaAttivita) &&
					!self.mostraAlert
				) {
					self.selectedValueOk({
						item: self.adeguataVerifica
					});
				} else {
					self.selectedValueNotOk && self.selectedValueNotOk({
						item: self.adeguataVerifica
					});
				}
			};

			var checkCongruenza = function (value) {
				var codice = value.description.split("|");
				if (codice == "ALL") {
					self.mostraAlert = false;
					return;
				}
				if (self.isPv && !!self.saePvControl) {
					self.riUserG = {
						sae: self.saePvControl
					}
				}
				if (!self.riUserG) {
					return
				}
				codice.forEach(function (element) {

					if (self.riUserG.sae == element) {
						self.mostraAlert = false;
					}
					else {
						self.mostraAlert = true;
					}
				})
			}
		}
	},
	);